const category = {
  title: '漫画分类',
  subtitle: '按类型浏览你喜欢的漫画，发现更多精彩作品',
  allCategories: '全部漫画',
  resultCount: '共 {{count}} 部作品',
  noResult: '暂无该分类的漫画',
  sortBy: '排序',
  sortOptions: {
    latest: '最新更新',
    popular: '最受欢迎',
    rating: '评分最高',
  },
};

export default category;